// Usuarios de solo auditoría: no pueden cancelar pólizas ni descargar Excel.
const AUDIT_USER_EMAILS = ['chubbauditoria@tryger.com'];

export const isAuditUser = (email?: string | null): boolean =>
  !!email && AUDIT_USER_EMAILS.includes(email.trim().toLowerCase());
